<template>
  <div class="forgot-password-container">
    <vue-particles
        :color="'#AEDFFE'"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        style="height: 100%;"
    />
    <div class="title-container">
      <div class="flex flex-ac">
        <div class="main-title">Doneist</div>
        <div class="sub-title">开放平台</div>
      </div>
      <div class="slogan">
        __助力数字技术革新,为产业赋能_
      </div>
    </div>
    <el-form :model="forgotPasswordForm" :rules="rules" ref="forgotPasswordForm" label-position="left" label-width="0px" class="forgot-password-page">
      <div class="title">忘记密码</div>
      <el-form-item prop="email">
        <el-input placeholder="请输入您的邮箱" v-model="forgotPasswordForm.email" prefix-icon="el-icon-message" @keyup.native.enter="sendResetPasswordLink"></el-input>
      </el-form-item>
      <el-form-item prop="verificationCode">
        <div class="display-inline-block">
          <el-input class="valid_code_input" placeholder="验证码" v-model="forgotPasswordForm.verificationCode" prefix-icon="el-icon-ice-cream-square" @keyup.native.enter="sendResetPasswordLink"></el-input>
          <el-button type="text" @click="sendVerificationCode">{{sendText}}</el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" id="forgotPasswordButton" style="width:100%;" :loading="loading" @click="sendResetPasswordLink">获取新的密码</el-button>
      </el-form-item>
      <router-link class="flex-ajc register" to="/userLogin">
        记得密码了？去登录>>
      </router-link>
    </el-form>
  </div>
</template>

<script>
import {getEmailCodeByResetPassword} from "@/api/systemApi";
import {validateNumInteger} from "@/utils/validateUtil";
export default {
  data() {
    return {
      loading: false,
      forgotPasswordForm: {
        email: '',
        verificationCode:''
      },
      sendText: '发送验证码',
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        verificationCode: [{
          validator:validateNumInteger,
          required: true,
          message: '请输入正确的验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted() {
    this.initGeeTest();
  },
  methods: {
    initGeeTest() {
      let _this = this;
      window.initGeetest4({
        captchaId: 'b6c16f2da2ee987963690692e8424dd3',
        product: 'bind',
        protocol: "https://"
      }, function (captcha) {
        // captcha为验证码实例
        window.captcha = captcha;
        captcha.onReady(function () {
          //your code
        }).onSuccess(function () {
          let result = window.captcha.getValidate();
          let data = _this.forgotPasswordForm;
          data['lotNumber'] = result.lot_number;
          data['captchaOutput'] = result.captcha_output;
          data['passToken'] = result.pass_token;
          data['genTime'] = result.gen_time;
          _this.getEmailCodeByResetPassword(data)
        }).onError(function () {
          //your code
        }).onClose(function () {
          // 用户把验证关闭了，这时你可以提示用户需要把验证通过后才能进行后续流程
          // _this.loading = false;
        });
      });
    },
    // 调用后端API发送验证码到邮箱的逻辑
    sendVerificationCode() {
      // 这里只是一个示例，你需要根据实际情况来实现这部分逻辑
      if (this.forgotPasswordForm.email) {
        // 校验通过，请求登录
        this.captchaType = 'getCode'
        window.captcha.showCaptcha();
      } else {
        this.$message.warning('请先输入邮箱地址！');
      }
    },
    // 获取邮箱验证码By注册
    getEmailCodeByResetPassword(data) {
      getEmailCodeByResetPassword(data).then(response => {
        if (response.code === 200) {
          // 处理发送成功的逻辑，比如显示一个提示信息给用户
          this.$message.success('验证码已发送到您的邮箱，请查收！');
          // 已发送
          // this.sendText = "已发送";
        }
      }).catch(() => {
        // 处理发送失败的逻辑，比如显示一个错误信息给用户
        this.$message.error('发送验证码失败，请稍后再试！');
      });
    },
    sendResetPasswordLink() {
      this.$refs.forgotPasswordForm.validate(valid => {
        if (valid) {
          this.loading = true;
          // 调用后端API发送重置密码链接到邮箱的逻辑
          this.$store.dispatch('user/resetPassword',this.forgotPasswordForm).then(()=>{
            this.loading = false;
            this.forgotPasswordForm.verificationCode="";
            // 休眠
            setTimeout(() => {
              // 跳转登录
              this.$router.push('/userLogin').then(()=>{})
            }, 1000);
          }).catch(()=> {
            this.loading = false;
            this.forgotPasswordForm.verificationCode="";
          })
        } else {
          console.log('验证失败!');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.forgot-password-page {
  position: absolute;
  top: 22%; /* 调整垂直位置 */
  left: 60%; /* 调整水平位置 */
  -webkit-border-radius: 10px;
  border-radius: 10px;
  width: 286px; /* 根据需要调整宽度 */
  padding: 35px 45px 20px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.forgot-password-container {
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/password_back.jpg'); /* 背景图，请根据实际情况修改路径 */
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.title-container {
  position: absolute;
  top: 4rem;
  left: 6rem;
}

.main-title {
  font-size: 42px;
  font-weight: bolder;
  color: #fff;
}

.sub-title {
  font-size: 32px;
  font-weight: bolder;
  color: #fff;
  margin-left: 0.2rem;
}

.slogan {
  font-size: 24px;
  font-weight: bolder;
  color: #fff;
}

.title {
  text-align: center;
  font-weight: bolder;
  font-size: 17px;
  margin-bottom: 0.5rem;
  margin-top: 0.2rem;
  opacity: 0.88;
}

.valid_code_input {
  width: 68%;
  margin-right: 16px;
}

.register {
  color: #3a8ee6;
  margin-bottom: 20px;
  font-weight: bold;
  opacity: 0.6;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .title-container {
    left: 50%;
    transform: translateX(-50%);
    top: 4rem;
    text-align: center;
    padding: 0 15px; /* 添加左右内边距，防止文字溢出 */
  }

  .main-title {
    font-size: 28px; /* 进一步减小标题字体 */
  }

  .sub-title {
    font-size: 20px; /* 减小副标题字体 */
  }

  .slogan {
    font-size: 14px; /* 减小slogan字体 */
    margin-top: 0.5rem;
    white-space: nowrap; /* 防止slogan换行 */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .forgot-password-page {
    left: 50%;
    transform: translateX(-50%);
    top: 35%; /* 调整表单垂直位置 */
    width: 80%; /* 增加表单宽度占比 */
    max-width: 300px; /* 设置最大宽度 */
    padding: 30px 20px; /* 优化内边距 */
    box-shadow: 0 3px 15px rgba(0,0,0,0.1); /* 优化阴影效果 */
  }

  .valid_code_input {
    width: 62%;
    margin-right: 12px;
  }

  .register {
    font-size: small;
    font-weight: bold;
  }

  /* 优化输入框和按钮大小 */
  .el-input {
    height: 44px;
  }

  .el-button {
    height: 44px;
    font-size: 16px;
  }
}
</style>